'use client';

import { AppImageClient } from '@components/appImage';
import { Sanitizer } from '@components/sanitizer';
import { Swiper, SwiperSlide } from 'swiper/react';

import { ApiSectionProps } from '../types';

import { Button } from '@/shared/components/button';

export const ApiSlider = ({
  cards,
  imagesMap,
  translations,
}: ApiSectionProps) => {
  return (
    <Swiper spaceBetween={12} slidesPerView="auto" className="!px-[20px]">
      {[...cards]
        .sort((a, b) => a.order - b.order)
        .map((card, index) => (
          <SwiperSlide key={index}>
            <div
              key={index}
              className="bg-surface-base-secondary m-h-[290px] flex h-full flex-col justify-between rounded-[20px] p-6"
            >
              <div>
                <p className="text-text-base-primary text-[20px] leading-[24px] font-medium">
                  {translations[card.title]}
                </p>

                <p className="text-text-base-primary mt-3 mb-6 text-[16px] leading-[24px] font-normal">
                  <Sanitizer
                    htmlContent={translations[card.description]}
                    className="[&_a]:text-text-base-primary whitespace-break-spaces [&_a]:underline"
                  />
                </p>
              </div>

              <div className="flex items-center justify-between">
                <AppImageClient
                  {...imagesMap[card.imgSrcKey]}
                  width={48}
                  height={48}
                  alt={card.title}
                  className="h-[48px] w-[48px]"
                />
                <Button
                  variant={'secondary'}
                  className="mt-auto flex h-[56px] w-fit items-center justify-center px-6"
                  href={card.href}
                >
                  {translations.documentation}
                </Button>
              </div>
            </div>
          </SwiperSlide>
        ))}
    </Swiper>
  );
};
